<cs-item-list>
  <cs-item>
    <cs-label>Static hint bubble (always visible):</cs-label>
  </cs-item>
  <cs-item>
    <div item-right style="position: relative; padding: 20px 0;">
      <span #staticTarget style="padding: 10px; background: rgba(255,255,255,0.1); border-radius: 4px;">
        This text has a hint bubble attached
      </span>
      <hint-bubble [target]="staticTarget" position="below">
        <p>This is a static hint bubble that appears immediately.</p>
        <p>It uses the new popup menu styling with dark background.</p>
      </hint-bubble>
    </div>
  </cs-item>

  <cs-item>
    <cs-label>Dynamic hint bubble (toggle with button):</cs-label>
  </cs-item>
  <cs-item>
    <cs-button item-right (click)="toggleDynamicHint()" [label]="(showDynamicHint ? 'Hide Hint' : 'Show Hint') | untranslated"
      data-test="toggle-hint" fit-width>
    </cs-button>
  </cs-item>
  @if (showDynamicHint) {
    <cs-item>
      <div item-right style="position: relative; padding: 20px 0;">
        <span #dynamicTarget style="padding: 10px; background: rgba(255,255,255,0.1); border-radius: 4px;">
          Dynamic hint target text
        </span>
        <hint-bubble [target]="dynamicTarget" position="above">
          <p>This hint appears above the text.</p>
          <p>Notice the arrow pointing down to the target.</p>
        </hint-bubble>
      </div>
    </cs-item>
  }

  <cs-item>
    <cs-label>Dismissible hint bubble:</cs-label>
  </cs-item>
  <cs-item>
    <div item-right style="position: relative; padding: 20px 0;">
      <span #dismissTarget style="padding: 10px; background: rgba(255,255,255,0.1); border-radius: 4px;">
        Click outside to dismiss the hint
      </span>
      <hint-bubble [target]="dismissTarget" position="below" dismiss acceptLabel="Got it!">
        <p>This hint bubble can be dismissed by:</p>
        <ul>
          <li>Clicking outside</li>
          <li>Clicking the "Got it!" link</li>
        </ul>
      </hint-bubble>
    </div>
  </cs-item>
</cs-item-list>
